<script setup lang="ts">
import { Check, X } from 'lucide-vue-next'

// The live region stays mounted even when empty so the first message is announced too.
defineProps<{ password: string; confirm: string; id: string }>()
</script>

<template>
  <p :id="id" aria-live="polite" class="mt-1 text-xs">
    <span v-if="confirm && confirm === password" class="flex items-center gap-1.5 text-cc-success">
      <Check class="w-3.5 h-3.5 shrink-0" aria-hidden="true" /> Passwords match
    </span>
    <span v-else-if="confirm" class="flex items-center gap-1.5 text-cc-danger">
      <X class="w-3.5 h-3.5 shrink-0" aria-hidden="true" /> Passwords don't match
    </span>
  </p>
</template>
